import consolv from 'lib/consolv';

const defaultConfig = {
  enabled: false,
  timeout: 1000,
  failsafeTimeout: 2000,
};

function setupIXGlobals() {
  window.headertag = window.headertag || {};
  window.headertag.cmd = window.headertag.cmd || [];
}

/* eslint-disable */
function setIXTargeting(demand) {
  if (!demand || !demand.slot) return;

  window.googletag.pubads().getSlots().forEach(function(slot) {
    var div = slot.getSlotElementId();
    if (demand.slot.hasOwnProperty(div)) {
      var allBids = {};
      demand.slot[div].forEach(function(bid) {
        for (var key in bid.targeting) {
          if (allBids.hasOwnProperty(key))
              allBids[key].push(bid.targeting[key][0])
          else {
              allBids[key] = bid.targeting[key];
          }
        }
      })
      for (var key in allBids) {
          slot.setTargeting(key, allBids[key]);
      }
    }
  })
}
/* eslint-enable */

/**
 * Creates the Index Exchange request and callback that is called before loading slots
 * @param {MCPInstance} MCP
 * @param {Object} [config]
 */
const setupRequestBids = (MCP, config) => (event, { slots, addAsyncEvent }) => {
  const runPerformanceTest = MCP._config.performanceTest === true;
  let startTime;
  if (runPerformanceTest) startTime = window.performance.now();

  const asyncEvent = new Promise((resolve) => {
    const { headertag } = window;
    const { slots: slotMap = [], failsafeTimeout } = config;
    let failsafeTimerRef;

    /* eslint-disable-next-line no-unused-vars */
    const adUnits = Array.from(slots).reduce((acc, [element, slot]) => {
      if (slotMap.includes(slot.type) && slot.sizeMap.length) {
        acc.push({ htSlotName: slot.id });
      }
      return acc;
    }, []);

    if (!adUnits.length) {
      consolv.log('MCP: IndexExchange has no valid ad units');
      resolve();
      return;
    }

    consolv.log('MCP: IndexExchange bids ready', adUnits);

    /* eslint-disable-next-line prefer-const */
    failsafeTimerRef = window.setTimeout(() => {
      consolv.log(`MCP: IndexExchange failsafe timeout exceeded at ${failsafeTimeout} seconds`);
      resolve();
    }, failsafeTimeout);

    /* eslint-disable-next-line prefer-arrow-callback */
    headertag.cmd.push(function retrieveDemand() {
      headertag.retrieveDemand(adUnits,
        (demand) => {
          window.clearTimeout(failsafeTimerRef);
          setIXTargeting(demand);

          if (runPerformanceTest) {
            const requestDuration = (window.performance.now() - startTime) / 1000;
            consolv.log('MCP: IndexExchange requests received', demand, `${requestDuration} seconds`);
          } else {
            consolv.log('MCP: IndexExchange requests received', demand);
          }

          resolve();
        });
    });
  });

  addAsyncEvent(asyncEvent);
};

/**
 * Generates the configuration and sets up event listeners for slot loads
 */
export default function IndexExchangeAdapter(MCP) {
  setupIXGlobals();

  MCP.loaded.then(() => {
    const { indexExchange } =
      MCP.Configurator.getConfiguration({ defaults: { indexExchange: defaultConfig } });

    if (indexExchange.enabled) {
      const requestBids = setupRequestBids(MCP, indexExchange);

      MCP.addEventListener('beforeRefreshSlots',
        (...params) => requestBids('beforeRefreshSlots', ...params));
    }
  });
}
